import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Feriado } from '../feriado';
import { FeriadoService } from '../feriado.service';

@Component({
  selector: 'app-feriado-maintenance',
  templateUrl: './feriado-maintenance.component.html',
  styleUrls: ['./feriado-maintenance.component.css']
})
export class FeriadoMaintenanceComponent implements OnInit {

  isInfo: boolean = false;

  feriado: Feriado;

  formularioFeriado: FormGroup;

  tituloCrud: string = '';

  constructor(private feriadoService: FeriadoService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.feriado = history.state.feriado;

    if (this.feriado) {
      this.isInfo = true;
    } else {
      this.isInfo = false;
      this.feriado = new Feriado();
    }

    this.formularioFeriado = this.formBuilder.group({
      dataFeriado: ['', [Validators.required]],
      descricaoFeriado: ['', [Validators.required, Validators.minLength(3)]],
    });
  }

  ngOnInit() {

    if (this.isInfo) {
      this.tituloCrud = 'Detalhe Feriado';
    } else {
      this.tituloCrud = 'Criar Feriado';
    }

    this.configurarForm();
  }

  save() {

    this.feriado = this.formularioFeriado.value;

    if (this.isNew()) {
      this.feriadoService
        .criar(this.feriado).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/feriados']);
  }

  isNew(): boolean {
    return !this.isInfo;
  }

  get formControl() {
    return this.formularioFeriado.controls;
  }

  configurarForm(): void {
    if (!this.isNew()) {
      // console.log(data)

      this.formularioFeriado.setValue(this.feriado);

      //Configurar Data do Feriado
      this.formularioFeriado.controls.dataFeriado.setValue(
        new Date(this.feriado.dataFeriado.toString().replace('-', '/')));

      this.cd.detectChanges();

      this.formularioFeriado.disable();
    } else {
      this.formularioFeriado.setValue({
        dataFeriado: '',
        descricaoFeriado: '',
      });
    }
  }

}